<template>
    <form id="MaritalStatusForm" @submit.prevent="form.post(action)">
        <RadioGroupField
            v-model="form.marital_status"
            name="marital_status"
            :error="translateMaybe(form.errors.marital_status)"
            :options="OPTIONS.MARITAL_STATUSES"
            class="mt-2"
            lg
            setup
            :option-classes="grid.md ? 'text-h4 my-2' : 'my-3'"
        />
    </form>
</template>

<script setup>
import RadioGroupField from "@/Components/FormFields/RadioGroupField.vue";
import { OPTIONS } from "@/Helpers/constants.js";
import { translateMaybe } from "@/Helpers/translateMaybe.js";
import { useForm } from "@inertiajs/vue3";
import { useGrid } from "vue-screen";
import { watchEffect } from "vue";

const props = defineProps({
    action: {
        type: String,
        default: null,
    },
    maritalStatus: {
        type: String,
        default: "",
    },
    form: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(["form-complete"]);
const grid = useGrid("tailwind");

const form =
    props.form ??
    useForm({
        marital_status: props.maritalStatus,
    });

watchEffect(() => {
    emit("form-complete", Boolean(form.marital_status));
});
</script>
